export default {"src":"/_next/static/media/wine.3b6c0369.svg","height":661,"width":661,"blurWidth":0,"blurHeight":0};